import { Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface IProps {
    loading: boolean
}

const Loading = (props: IProps) => {
    const {
        loading
    } = props;

    const [showLoading, setShowLoading] = useState(false);

    const domRef = useRef(null);

    useEffect(() => {
        if (loading) {
            const dom = document.createElement('div');
            dom.setAttribute('id', 'loading');
            document.body.appendChild(dom);
            domRef.current = dom;
            setShowLoading(true);
        } else {
            const elements = document.getElementById('loading');
            if (elements) {
                document.body.removeChild(elements);
            }
            setShowLoading(false);
        }
    }, [loading]);

    return showLoading ? createPortal(<Spin
        style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
        }}
        tip='loading'
        size="large"
    />, domRef.current) : null;
};

export default Loading;